export default __webpack_public_path__ + "static/media/react.e27571ea.svg";